var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10",
    filter: "url(#filter0_b_280_1024)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4938 5.0018C10.495 5.1329 10.4446 5.2592 10.3535 5.3535L6.6035 9.1035C6.50974 9.19724 6.38258 9.24989 6.25 9.24989C6.11742 9.24989 5.99026 9.19724 5.8965 9.1035L3.8965 7.1035C3.80542 7.0092 3.75502 6.8829 3.75616 6.7518C3.7573 6.6207 3.80989 6.49529 3.90259 6.40259C3.99529 6.30989 4.1207 6.2573 4.2518 6.25616C4.3829 6.25502 4.5092 6.30542 4.6035 6.3965L6.25 8.043L9.6465 4.6465C9.7408 4.55542 9.8671 4.50502 9.9982 4.50616C10.1293 4.5073 10.2547 4.55989 10.3474 4.65259C10.4401 4.74529 10.4927 4.8707 10.4938 5.0018Z",
    fill: "#00FFF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_280_1024",
    x: -7.8,
    y: -7.8,
    width: 29.6,
    height: 29.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_280_1024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_280_1024",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.774e41f2938322ad66e960ca2ab76f9f.svg";
export { ForwardRef as ReactComponent };